import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵinject, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { BehaviorSubject, concat, combineLatest } from 'rxjs';
import { formatDistance } from 'date-fns';
import { shareReplay, map } from 'rxjs/operators';

class DataModelService {
    constructor() {
        /*
        blank
        */
    }
}
DataModelService.ɵfac = function DataModelService_Factory(t) { return new (t || DataModelService)(); };
DataModelService.ɵprov = ɵɵdefineInjectable({ token: DataModelService, factory: DataModelService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DataModelService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

class DataModelComponent {
    constructor() {
        /*
    blank
    */
    }
    ngOnInit() {
        /*
        blank
        */
    }
}
DataModelComponent.ɵfac = function DataModelComponent_Factory(t) { return new (t || DataModelComponent)(); };
DataModelComponent.ɵcmp = ɵɵdefineComponent({ type: DataModelComponent, selectors: [["dm-data-model"]], decls: 2, vars: 0, template: function DataModelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, "data-model works!");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DataModelComponent, [{
        type: Component,
        args: [{
                selector: 'dm-data-model',
                template: ` <p>data-model works!</p> `,
                styles: [],
            }]
    }], function () { return []; }, null); })();

class BobService {
    constructor(http) {
        this.http = http;
        this.bobdata = new BehaviorSubject(null);
        this.bobdata$ = this.bobdata.asObservable();
        this.getHeaders();
    }
    getHeaders() {
        return __awaiter(this, void 0, void 0, function* () {
            this.headers = {
                "Content-Type": "application/json",
                Accept: "application/json"
            };
            // if (token) {
            //   obj.Authorization = token;
            // }
            // await this.configService.getAPIHeader();
        });
    }
    createuserlead(user) {
        try {
            this.getHeaders();
            const leadJson = {};
            const nameArr = user.displayName.split(" ");
            leadJson["email"] = user.email;
            leadJson["firstName"] = nameArr[0];
            leadJson["lastName"] = (nameArr.length > 1) ? nameArr[1] : "";
            const httpOptions = {
                headers: new HttpHeaders(this.headers),
                params: new HttpParams(leadJson)
            };
            this.http.post("http://terra-bob-service-lb-1309672784.us-east-1.elb.amazonaws.com/builder/lead", {}, httpOptions).subscribe(() => { });
        }
        catch (error) {
            return error;
        }
    }
}
BobService.ɵfac = function BobService_Factory(t) { return new (t || BobService)(ɵɵinject(HttpClient)); };
BobService.ɵprov = ɵɵdefineInjectable({ token: BobService, factory: BobService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BobService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

class TerraCohortsService {
    constructor(http) {
        this.http = http;
        this.headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };
        // dev
        this.COHORT_URL = 'https://terra-api.terra.do/dev/cohortdev';
        // prod
        // public COHORT_URL = 'https://cohort.terra.do/cohort';
        this.cohort = new BehaviorSubject(null);
        this.cohort$ = this.cohort.asObservable();
        this.events = new BehaviorSubject(null);
        this.events$ = this.events.asObservable();
    }
    getCohortByEmail(email, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/v2/student/${email}/cohorts/v2`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getFullCohortsDetailsByEmail(email, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/student/${email}/allCohorts`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getCohortEventsByEmail(cohortId, email, accessToken) {
        this.cohortEvents$ = this.http
            .get(`${this.COHORT_URL}/${cohortId}/student/${email}/events/v2`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
        this.cohortEvents$ = this.cohortEvents$.pipe(map(cohorts => {
            cohorts.events.classes = cohorts.events.classes.map(cohort => {
                cohort.difference = formatDistance(new Date(cohort.startDateTime), new Date(cohort.endDateTime));
                return cohort;
            });
            return Object.assign(Object.assign({}, cohorts), { cohortId });
        }), shareReplay());
        return this.cohortEvents$;
    }
    getCalendarEventsByEmail(cohortArray, email, accessToken) {
        // console.log('cohorts = ', cohortArray);
        let allEvents = null;
        for (let i = 0; i < cohortArray.length; i++) {
            if (i === 0) {
                allEvents = this.getCohortEventsByEmail(cohortArray[i].cohortId, email, accessToken);
            }
            else {
                allEvents = concat(this.getCohortEventsByEmail(cohortArray[i].cohortId, email, accessToken), allEvents);
            }
        }
        allEvents = allEvents.pipe(shareReplay());
        return allEvents;
    }
    getAssignmentEventsByEmail(cohortId, email, accessToken) {
        this.cohortEvents$ = this.http.get(`${this.COHORT_URL}/${cohortId}/student/${email}/assignments/V2`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        });
        let classDetail$ = null;
        classDetail$ = this.getClassesByCohortId(cohortId, accessToken);
        // this.cohortEvents$ = this.cohortEvents$.pipe(
        // 	map(cohort => {
        // 		return {
        // 			...cohort,
        // 			cohortId,
        // 			activeAssignment: '',
        // 			classDetail
        // 			classLoaded: true
        // 		};
        // 	}),
        // 	shareReplay(),
        // );
        this.cohortEvents$ = combineLatest([this.cohortEvents$, classDetail$]).pipe(map(([cohort, classDetail]) => {
            return Object.assign(Object.assign({}, cohort), { cohortId, activeAssignment: '', classDetail, classLoaded: true });
        }), shareReplay());
        return this.cohortEvents$;
    }
    getAssignmentsForCohortByEmail(cohortArray, email, accessToken) {
        let allAssignments = null;
        for (let i = 0; i < cohortArray.length; i++) {
            if (i === 0) {
                allAssignments = this.getAssignmentEventsByEmail(cohortArray[i].cohortId, email, accessToken);
            }
            else {
                allAssignments = concat(this.getAssignmentEventsByEmail(cohortArray[i].cohortId, email, accessToken), allAssignments);
            }
        }
        allAssignments = allAssignments.pipe(shareReplay());
        /*this.pendingAssignments$ = allAssignments.pipe(
            map(aevent => {
                return aevent.assignments.map(response => {
                    return { ...response, course: aevent.course };
                });
            }),
            mergeAll(),
            filter(x => x['status'] !== 'submitted'),
            // take(1),
        );

        this.completedAssignments$ = allAssignments.pipe(
            map(aevent => {
                return aevent.assignments.map(response => {
                    return { ...response, course: aevent.course };
                });
            }),
            mergeAll(),
            filter(x => x['status'] === 'submitted'),
            // take(1),
        );*/
        return allAssignments;
    }
    createAssignmentSession(email, displayName, PAD_ID) {
        return this.http
            .get(`${this.COHORT_URL}/session/${email}/${displayName}/${PAD_ID}/${Date.now() + 1000 * 60 * 60 * 24 * 30}`, { headers: new HttpHeaders(this.headers) })
            .pipe(shareReplay());
    }
    getAssignmentDetail(email, assignmentId, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/student/${email}/assignment/${assignmentId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getAssignmentDetailForReadOnlyAssignment(assignmentId, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/assignment/submission/${assignmentId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getAllAssignmentsByCohort(cohortId) {
        return this.http
            .get(`${this.COHORT_URL}/assignments/${cohortId}`)
            .pipe(shareReplay());
    }
    createAssignment(createAssignmentObj, accessToken) {
        return this.http
            .post(`${this.COHORT_URL}/createAssignment`, createAssignmentObj, {
            headers: new HttpHeaders(Object.assign(Object.assign({}, this.headers), { Authorization: 'Bearer ' + accessToken })),
        })
            .pipe(shareReplay(), map((response) => {
            if (!response.groupPadId && !response.submissionId) {
                throw response.message;
            }
            else {
                return response;
            }
        }));
    }
    allAssignmentByAssignmentId(assignmentId, groupId, groupName, limit, page, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/assignments/assignment/${assignmentId}/${groupId}/${groupName}/limit/${limit}/page/${page}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    otherAssignmentByChortId(cohortId, searchObj, accessToken) {
        let url = ``;
        if (searchObj.studentEmail) {
            url = `${this.COHORT_URL}/${cohortId}/student/${searchObj.studentEmail}/assignments/limit/${searchObj.limit}/page/${searchObj.page}`;
        }
        else if (searchObj.assignment) {
            url = `${this.COHORT_URL}/assignments/assignment/${searchObj.assignment}/limit/${searchObj.limit}/page/${searchObj.page}`;
        }
        else {
            url = `${this.COHORT_URL}/${cohortId}/assignments/limit/${searchObj.limit}/page/${searchObj.page}`;
        }
        return this.http
            .get(url, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getClassMatesByCohortId(cohortId, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/${cohortId}/students/V2`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    addMemberToGroupAssignment(assignObj) {
        return this.http
            .post(`${this.COHORT_URL}/assignmentGroup`, assignObj, {
            headers: new HttpHeaders(this.headers),
        })
            .pipe(shareReplay());
    }
    removeGroupAssignment(email, assignmentId, accessToken) {
        return this.http
            .delete(`${this.COHORT_URL}/student/${email}/assignment/${assignmentId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getInstructorDetailByCohortId(cohortId, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/${cohortId}/people`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getCourseMaterialByCohortId(courseId, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/${courseId}/materials`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getNotesByEmailAndCohortId(cohortId, email, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/${cohortId}/student/${email}/notesWithClass`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getSyllabusByCohortId(cohortId, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/${cohortId}/syllabus`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getClassesByCohortId(cohortId, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/${cohortId}/modules`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getCommentsOfAssignmentByEmail(email, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/v2/assignment/comments/${email}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(map((response) => {
            if (!!response && response['data']) {
                return response['data'];
            }
            else {
                return [];
            }
        }), shareReplay());
    }
    markClassCompleted(classId, accessToken) {
        return this.http
            .post(`${this.COHORT_URL}/class/${classId}/mark`, {}, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    publishEvent(createEvent, accessToken) {
        const eventId = createEvent.calendarType === 'cohortCal'
            ? createEvent.cohortCalId
            : createEvent.groupCalId;
        return this.http
            .post(`${this.COHORT_URL}/calendar/${eventId}/event`, createEvent, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    updateEvent(updateEvent, eventId, accessToken) {
        const eventCal = updateEvent.calendarType === 'cohortCal'
            ? updateEvent.cohortCalId
            : updateEvent.groupCalId;
        return this.http
            .put(`${this.COHORT_URL}/calendar/${eventCal}/event/${eventId}`, updateEvent, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    zoomAttendance(eventId, eventType, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/join/${eventType}/${eventId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    deleteEvent(eventData, accessToken) {
        const eventCal = eventData.calendarType === 'cohortCal'
            ? eventData.cohortCalId
            : eventData.groupCalId;
        return this.http
            .delete(`${this.COHORT_URL}/calendar/${eventCal}/event/${eventData.eventId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getSubmissionDetail(submissionId, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/assignment/submission/${submissionId}/html`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    updateContentOnSubmission(submissionId, submissionDetail, accessToken) {
        return this.http
            .post(`${this.COHORT_URL}/assignment/submission/${submissionId}/html`, submissionDetail, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay(), map((response) => {
            if (response.count === 1) {
                return response;
            }
            else {
                throw response.message;
            }
        }));
    }
    submitAssignment(submissionDetail, accessToken) {
        return this.http
            .post(`${this.COHORT_URL}/v2/submitAssignment`, submissionDetail, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getAllCohorts(accessToken) {
        return this.http
            .get(`https://cohort.terra.do/catalog/course/list/all`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getOtherCohortDetail(cohortId, accessToken) {
        return this.http
            .get(`${this.COHORT_URL}/${cohortId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    getOtherCohortCourseDetail(courseId, accessToken) {
        return this.http
            .get(`https://cohort.terra.do/catalog/course/${courseId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
    loadClassesForCohort(token, cohortId) {
        return this.http
            .get(this.COHORT_URL + `/${cohortId}/module/classes`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .pipe(shareReplay());
    }
    memberList(courseId, accessToken) {
        return this.http
            .get(this.COHORT_URL + `/v2/${courseId}/students`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + accessToken,
            }),
        })
            .pipe(shareReplay());
    }
}
TerraCohortsService.ɵfac = function TerraCohortsService_Factory(t) { return new (t || TerraCohortsService)(ɵɵinject(HttpClient)); };
TerraCohortsService.ɵprov = ɵɵdefineInjectable({ token: TerraCohortsService, factory: TerraCohortsService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TerraCohortsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

class DataModelModule {
    static forRoot() {
        return {
            ngModule: DataModelModule,
            providers: [TerraCohortsService, BobService],
        };
    }
}
DataModelModule.ɵmod = ɵɵdefineNgModule({ type: DataModelModule });
DataModelModule.ɵinj = ɵɵdefineInjector({ factory: function DataModelModule_Factory(t) { return new (t || DataModelModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DataModelModule, { declarations: [DataModelComponent], exports: [DataModelComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DataModelModule, [{
        type: NgModule,
        args: [{
                declarations: [DataModelComponent],
                imports: [],
                exports: [DataModelComponent],
            }]
    }], null, null); })();

/*
 * Public API Surface of data-model
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BobService, DataModelComponent, DataModelModule, DataModelService, TerraCohortsService };
//# sourceMappingURL=data-model.js.map
